import styled from 'styled-components/macro';

export const MenuRightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-medium);
`;
